import { Link } from "react-router-dom";
import styles from "./LoginFooter.module.css";
import { buildTenantRelativePath } from "../../utils/tenantPreview";
import { usePublicConfigValue } from "../../hooks/usePublicConfig";
import {
  isExternalMenuLink,
  resolveMenuRuntimeLink,
} from "../../utils/menuPageLinks";

function dedupeLinks(items = []) {
  const seen = new Set();
  return items.filter((item) => {
    const key = `${item?.label || ""}:${item?.to || ""}:${item?.openInNewTab ? "new" : "same"}`;
    if (!item?.label || !item?.to || seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
}

export default function LoginFooter() {
  const publicConfig = usePublicConfigValue();
  const isTenantScoped = Boolean(publicConfig?.tenant?.slug);
  const copyrightText = `${publicConfig?.general?.copyrightText || ""}`.trim();
  const tenantPath = (path) => buildTenantRelativePath(path);
  const resolveInternalLink = (path) => (isTenantScoped ? tenantPath(path) : path);
  const footerMenus = Array.isArray(publicConfig?.siteMenus?.footer)
    ? publicConfig.siteMenus.footer
    : [];
  const footerLinks = dedupeLinks(
    footerMenus.flatMap((menu) =>
      Array.isArray(menu?.items)
        ? menu.items.map((item) => ({
            label: `${item?.label || ""}`.trim(),
            to: resolveMenuRuntimeLink(item?.link),
            openInNewTab: item?.openInNewTab === true,
          }))
        : []
    )
  );
  const hasFooterContent = footerLinks.length > 0 || Boolean(copyrightText);

  if (!hasFooterContent) {
    return null;
  }

  return (
    <footer className={styles.footer}>
      {footerLinks.length ? (
        <div className={styles.warp}>
          {footerLinks.map((item) =>
            isExternalMenuLink(item.to) ? (
              <a
                key={`${item.label}:${item.to}`}
                href={item.to}
                target={item.openInNewTab ? "_blank" : undefined}
                rel={item.openInNewTab ? "noreferrer" : undefined}
              >
                {item.label}
              </a>
            ) : (
              <Link
                key={`${item.label}:${item.to}`}
                to={resolveInternalLink(item.to)}
                target={item.openInNewTab ? "_blank" : undefined}
                rel={item.openInNewTab ? "noreferrer" : undefined}
              >
                {item.label}
              </Link>
            )
          )}
        </div>
      ) : null}
      {copyrightText ? (
        <div className={styles.warp}>
          <span style={{ fontSize: "12px", marginTop: "10px" }}>
            {copyrightText}
          </span>
        </div>
      ) : null}
    </footer>
  );
}
